import I18n from "i18n-js"
import React from "react"

class DisabledForm extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="OrderFormBuilder" ref="form">
        <div className="alert alert-warning">
          <h4 style={{marginTop: '5px', textAlign: 'center'}}><strong><span className="ss-lock"></span>{` ${I18n.t('form_not_found')}`}</strong></h4>
          <hr/>
          <p className="text-center">{I18n.t('form_not_found_or_is_disabled', {name: this.props.title})}</p> 
        </div>
      </div>
    )
  }
}

export default DisabledForm